import React from "react";

export default function Stats({ tasks = [] }) {
  if (!tasks || tasks.length === 0) return null;
  const total = tasks.length;
  const done = tasks.filter((t) => t.status === "Done").length;
  const pending = total - done;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
      <div className="bg-white dark:bg-slate-900 p-5 rounded-2xl border dark:border-slate-800 shadow-sm">
        <span className="text-slate-400 text-[10px] font-black uppercase tracking-widest">
          Total Tasks
        </span>
        <p className="text-3xl font-black dark:text-white">{total}</p>
      </div>
      <div className="bg-white dark:bg-slate-900 p-5 rounded-2xl border dark:border-slate-800 shadow-sm border-b-4 border-b-emerald-500">
        <span className="text-emerald-500 text-[10px] font-black uppercase tracking-widest">
          Completed
        </span>
        <p className="text-3xl font-black text-emerald-500">{done}</p>
      </div>
      <div className="bg-white dark:bg-slate-900 p-5 rounded-2xl border dark:border-slate-800 shadow-sm border-b-4 border-b-amber-500 hidden md:block">
        <span className="text-amber-500 text-[10px] font-black uppercase tracking-widest">
          In Progress
        </span>
        <p className="text-3xl font-black text-amber-500">{pending}</p>
      </div>
    </div>
  );
}
